// Locales
import en from "./en.json";
import enLR from "./en_LR.json";

const translations = {
  en: { ...en },
  "en-LR": { ...enLR }
};

export default translations;
